import { propietarioApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'PROPIETARIO',
    api: propietarioApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'PROPIETARIO',
  api: propietarioApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'PROPIETARIO',
    api: propietarioApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'PROPIETARIO',
    api: propietarioApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'PROPIETARIO',
  api: propietarioApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'PROPIETARIO',
    api: propietarioApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('PROPIETARIO');
export const setDeletedPending = createListDataDeletedPending('PROPIETARIO');
